import 'core-js/es/object/assign'; // polyfill for when export/import directly
import environmentDefault from './environment-default';

const environmentWeb = {
  test: {
    hostname: 'test.ag.ch',
    logging: {
      log: true,
      debug: true,
      info: true,
      warn: true,
      error: true,
      target: 'console',
    },
  },

  stage: {
    hostname: 'quality.ag.ch',
    logging: {
      log: false,
      target: 'noop',
    },
    analytics: {
      trackers: [
        {
          name: 'global',
          trackerId: 'UA-78496845-1',
        },
        {
          name: 'itag',
          trackerId: 'UA-129681898-1',
        },
        {
          name: 'ga4',
          trackerId: 'G-TV5QXFNER1',
          type: 'ga4',
        },
      ],
    },
  },

  migration: {
    hostname: 'test2.ag.ch',
    logging: {
      log: false,
      target: 'noop',
    },
    analytics: {
      trackers: [
        {
          name: 'global',
          trackerId: 'UA-204006521-1',
        },
      ],
    },
  },

  production: {
    hostname: 'www.ag.ch',
    logging: {
      log: false,
      target: 'noop',
    },
    analytics: {
      trackers: [
        {
          name: 'global',
          trackerId: 'UA-35991255-1',
        },
        {
          name: 'itag',
          trackerId: 'UA-36332391-1',
        },
        {
          name: 'itag-ga4',
          trackerId: 'G-485GP381PZ',
          type: 'ga4',
        },
      ],
    },
  },
};

export default Object.assign(environmentDefault, environmentWeb);
